export class Dealers {
  constructor() {
    this._cards = document.querySelectorAll('[data-dealer-card]');
    this._modal = document.querySelector('[data-modal="dealer"]');
    this._modalContent = null;

    this._documentClickHandle = this._documentClickHandle.bind(this);
  }

  init() {
    if (!this._cards.length) {
      return;
    }

    if (this._modal) {
      this._modalContent = this._modal.querySelector('[data-modal-content]');
    }

    document.addEventListener('click', this._documentClickHandle);
  }

  async _documentClickHandle(evt) {
    const target = evt.target;

    this._modalContent.innerHTML = '';

    if (!target.closest('[data-dealer-card]')) {
      return;
    }

    const card = target.closest('[data-dealer-card]');
    const params = {
      id: card.dataset.dealerCard,
    };

    try {
      const response = await fetch('/local/templates/xylosuisse/ajax/get-dealer-info.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(params).toString(),
      })
      const result = await response.text();

      if (result) {
        this._modalContent.innerHTML = result;
      }
    } catch (err) {
      console.log('Error: ' + err);
    }
  }
}
